import { merge } from 'lodash'
import {
  SuperType,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  getAIArtWork_pictureGraph_aiArtwork,
  getShareInfo_pictureGraph_aiArtworkSharingInfo_sharingAiArtwork,
  TrainBaseModelType,
  AiArtworkOptionTypeEnum,
  getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_layerDiffusionModelThemeOption_defaultSelectStyleDecorationOption,
} from '~/graphqls/types'
import { setStorage } from '~/utils'

export type Product =
  | (Omit<
      getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
      '__typename'
    > & {
      trackEventLabel?: string | null
    })
  | (Omit<getAIArtWork_pictureGraph_aiArtwork, '_typename'> & {
      trackEventLabel?: string | null
    })
  | (Omit<
      getShareInfo_pictureGraph_aiArtworkSharingInfo_sharingAiArtwork,
      '_typename'
    > & {
      trackEventLabel?: string | null
    })

/** 设置再来一张的底层参数 */
export function setAgainParams(item: Product) {
  // console.log('item: ', item)
  const param = {
    prompt: item.prompt,
    model: item.model,
    styleModel: item.styleModelOption?.key,
    resolutionKey: item.resolutionKey,
    size: item.size,
    resolution: `${item.length}*${item.width}*${item.superType}`,
    character: item.characterOptions?.map(item => item.key),
    modelFusion: handleModelFusion({
      modelFusion: item.modelFusionOptions,
      userTrainedModel: item.userTrainedModelOption,
    }),
    // item.modelFusionOptions?.map(item => ({
    //   key: item.key,
    //   weight: item.weight,
    // })),
    styleDecorationOptions: item.styleDecorationOptions?.map(item => ({
      key: item.key,
      type: item.type,
    })),
    initImageUrl: item.initImageUrl,
    creativityDegree: item.creativityDegree,
    originUrl: item.miniArtWorkUrl,
    modelCode: item.modelCode,
    ucPrompt: item.ucPrompt,
    doRepairTheHand: item.doRepairTheHand,
    createSource: item.createSource || 0,
    cfg: item?.cfg,
    ensd: item?.ensd,
    clipSkip: item?.clipSkip,
    pretreatmentMethod: item.pretreatmentMethod || undefined,
    samplerModelInfo: item?.samplerModelInfo || undefined,
    superType: item?.superType || SuperType.SUPERSIZE,
    // 访问来源，用于统计该渠道来源
    trackEventLabel: item?.trackEventLabel || undefined,
    mjParam: item?.mjParam,
    layerDiffusion: item?.layerDiffusion,
    instantStyle: item?.instantStyle,
    cutDiffusion: item?.cutDiffusion,
    flux: item?.flux,
  }

  /** 更新的模型使用新的默认值 */
  if (
    item.modelDefaultParam?.modelParamChangeTime &&
    item.modelDefaultParam?.modelParamChangeTime > item.generateTime
  ) {
    merge(param, {
      cfg: item.modelDefaultParam.cfg,
      ensd: item.modelDefaultParam.ensd,
      clipSkip: item.modelDefaultParam.clipSkip,
      samplerModelInfo: {
        samplerIndex: item.modelDefaultParam.samplerIndex,
      },
    })
  }

  setStorage('aiParam', param)
}

export const UserTrainedModalVersionMap = {
  [TrainBaseModelType.SD15]: '1.x',
  [TrainBaseModelType.SD20]: '2.x',
  [TrainBaseModelType.SDXL]: 'sdxl',
}

/**
 * 处理融合模型
 */
export function handleModelFusion({
  modelFusion,
  userTrainedModel,
}: {
  [key: string]: any
}) {
  const _modelFusion =
    modelFusion?.map((item: any) => ({
      key: item.key,
      weight: item.weight,
    })) || []
  // 过滤掉不合法的模型
  const _userTrainedModel =
    userTrainedModel
      ?.filter((it: any) => !(it.trainedModel && !it.trainedModel.valid))
      ?.map((it: any) => {
        const itKey = it.id || it.trainedModel?.id
        const itName = it.name || it.trainedModel?.modelName
        return {
          key: `user_${itKey}`,
          weight: it.weight,
          name: itName,
        }
      }) || []
  return _modelFusion.concat(_userTrainedModel)
}

/** 默认标签字段处理 */
export const formatStyleDecorationItem = (
  styleDecorationOptions:
    | (getAIMenu_pictureGraph_aiCreateArtworkOptionMenu_layerDiffusionModelThemeOption_defaultSelectStyleDecorationOption | null)[]
    | null
    | undefined
) => {
  return styleDecorationOptions?.map(it => {
    return {
      type: it?.type as AiArtworkOptionTypeEnum,
      key: it?.key!,
      choiceKey: it?.choiceKey ?? 0,
    }
  })
}
